// src/components/project-save-button.tsx
import React from "react";
import { useTranslation } from "react-i18next";  
import Button from "@/components/ui/Button";

export function ProjectSaveButton({
  onSave,
  saving,
  disabled = false,
}: {
  onSave: () => void;
  saving: boolean;
  disabled?: boolean;
}
) {
  const { t } = useTranslation();

  return (
    <Button
      type="button"
      variant="orange"
      loading={saving}
      loadingText={t("common.saving")}
      onClick={onSave}
      disabled={disabled || saving}
      className="px-4 py-1.5 text-xs font-semibold"
    >
      {t("actions.save")}
    </Button>
  );
}

export default ProjectSaveButton;